export const ADDRESS_MAX_LENGTH = 50;
